import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchCustomers, fetchSAPValues } from '../actions/customers'

import CustomerList from '../components/CustomerList'
import ErrorMessage from '../components/ErrorMessage'
import '../styles/CustomersAdminView.css'

class CustomersView extends React.Component {
  constructor(props) {
    super(props)

    this.handleDownloadSAPValuesCSV = this.handleDownloadSAPValuesCSV.bind(this);
  }

  componentDidMount() {
    this.props.fetchCustomers()
  }

  handleDownloadSAPValuesCSV() {
    const { fetchSAPValues } = this.props

    fetchSAPValues();
  }

  render() {
    const { customers, loading, error } = this.props

    if (error) {
      return (
        <ErrorMessage message={error.message}/>
      )
    }

    if (!customers || loading) {
      return (
        <div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    return (
      <div className="customers-admin-view">
        <div className="customers-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-user mr-3"></i>
                <span className="text-vw-dark mr-1">CLIENTES</span>
              </h1>
            </div>
            <div className="header-actions">
              <Link to="/customers/add" className="customers-admin-btn primary">
                <i className="fas fa-plus"></i>
                <span>Nuevo Cliente</span>
              </Link>
              <button className="customers-admin-btn warning" onClick={this.handleDownloadSAPValuesCSV}>
                <i className="fas fa-file-excel"></i>
                <span>Descargar SAP</span>
              </button>
            </div>
          </div>
        </div>
        <CustomerList customers={customers} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  customers: state.customers.customers,
  error: state.customers.error,
  loading: state.customers.loading
})

const mapDispatchToProps = dispatch => ({
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  fetchSAPValues: bindActionCreators(fetchSAPValues, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomersView)

